export enum NotificationsRoutesEnum{
    NOTIFICATIONS_PREFIX   = 'notifications',
    NOTIFICATIONS_LIST     = 'notifications_list',
}
